import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { MContentHeaderAlignment } from './MContentHeader.types';

const { spacers } = baseVariables;

export const ContentHeaderWrapper = styled.div<{ $alignment?: MContentHeaderAlignment }>`
  display: flex;
  gap: ${spacers?.spacers?.[3] ?? '1rem'};
  padding-block-end: ${spacers?.spacers?.[4] ?? '1.5rem'};

  ${({ $alignment }) =>
    $alignment === MContentHeaderAlignment.Centered
      ? `
        flex-direction: column;
        align-items: center;
        text-align: center;
      `
      : `
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: space-between;
      `}
`;

export const TextBlockWrapper = styled.div<{ $alignment?: MContentHeaderAlignment }>`
  min-width: 0;
  max-width: ${({ $alignment }) => ($alignment === MContentHeaderAlignment.Centered ? '752px' : '768px')};

  ${({ $alignment }) => ($alignment !== MContentHeaderAlignment.Centered ? 'flex: 1 1 343px;' : '')}
`;
